
namespace GeniuzPOS.Purchase {

    @Serenity.Decorators.registerClass()
    export class ListAppPurRequestDialog extends Serenity.EntityDialog<ListAppPurRequestRow, any> {
        protected getFormKey() { return ListAppPurRequestForm.formKey; }
        protected getIdProperty() { return ListAppPurRequestRow.idProperty; }
        protected getLocalTextPrefix() { return ListAppPurRequestRow.localTextPrefix; }
        protected getNameProperty() { return ListAppPurRequestRow.nameProperty; }
        protected getService() { return ListAppPurRequestService.baseUrl; }
        protected getDeletePermission() { return ListAppPurRequestRow.deletePermission; }
        protected getInsertPermission() { return ListAppPurRequestRow.insertPermission; }
        protected getUpdatePermission() { return ListAppPurRequestRow.updatePermission; }

        protected form = new ListAppPurRequestForm(this.idPrefix);

    }
}